import React, { useState } from "react";
import { useTheme } from "../../../../context/useThemeContext";
import { hexToRGBA } from "../../../../utility/hexToRGB";
import useMainStore from "../../../../stores/mainStore";
import useDataStore from "../../../../stores/dataStore";
import styled from "styled-components";
import useAbsoluteWindowStore from "../../../../stores/absoluteWindowStore";
import { FolderContextMenu } from "../../../contextMenu";
import FolderIcon from "./folderIcon";
import FolderTitle from "./FolderTitle";
import NumSelectedInFolder from "./numSelectedInFolder";
import SelectionIndicator from "./selectionIndicator";
import { useNumberOpenedNotesInFolder } from "../..";

const FolderStyled = styled.div<{ $BGColor: string }>`
    &:hover {
        .innerContent {
            background-color: ${(props) => hexToRGBA(props.$BGColor, 0.06)};
        }
    }
`;

function Folder(props: { id?: string }) {
    // Context
    const { theme } = useTheme();

    // Hooks
    const numOpenedNotesInFolder = useNumberOpenedNotesInFolder(props.id);

    // State
    const [isRenamingFolder, setIsRenamingFolder] = useState(false);

    function onClick() {
        useMainStore
            .getState()
            .set.selectedFolderID((fn) => props.id || "uncategorized");
    }

    function onContextMenu(e: React.MouseEvent) {
        useAbsoluteWindowStore.getState().setPosition(e.clientX, e.clientY);
        useAbsoluteWindowStore.getState().setWindowShowing({
            type: "ContextMenu",
            children: (
                <FolderContextMenu
                    folderID={props.id}
                    renameFolder={() => {
                        setIsRenamingFolder(true);
                    }}
                    deleteFolder={() => {
                        if (!props.id) return;

                        useDataStore.getState().remove.folder(props.id);
                    }}
                    addNote={() => {
                        // Create Note
                        const newNote = useDataStore.getState().add.note({
                            folderID: props.id,
                        });

                        // Open Note
                        useMainStore
                            .getState()
                            .set.openedNoteIDs(
                                (prev) => prev && [...prev, newNote]
                            );

                        // Select Note
                        useMainStore
                            .getState()
                            .set.selectedNoteID((prev) => newNote);

                        // Open Folder
                        useMainStore
                            .getState()
                            .set.selectedFolderID(() =>
                                props.id ? props.id : "uncategorized"
                            );
                    }}
                    openFolder={() => {
                        useMainStore
                            .getState()
                            .set.selectedFolderID(() =>
                                props.id ? props.id : "uncategorized"
                            );
                    }}
                />
            ),
        });
    }

    return (
        <FolderStyled
            $BGColor={theme.accentColor}
            className="flex flex-shrink-0 py-[2px] relative cursor-pointer"
            style={{
                borderBottom: `1px solid ${theme.mainContentColor}`,
            }}
            onClick={(e) => {
                e.stopPropagation();
                onClick();
            }}
            onContextMenu={(e) => {
                e.preventDefault();
                e.stopPropagation();
                onContextMenu(e);
            }}
        >
            <div className="innerContent flex-1 gap-[11px] px-[8px] flex items-center py-2 rounded-[6px]">
                <FolderIcon id={props.id} />
                <FolderTitle
                    id={props.id}
                    isRenamingFolder={isRenamingFolder}
                    setIsRenamingFolder={setIsRenamingFolder}
                />

                <NumSelectedInFolder
                    id={props.id}
                    numOpenedNotesInFolder={numOpenedNotesInFolder}
                />
                <SelectionIndicator
                    id={props.id}
                    numOpenedNotesInFolder={numOpenedNotesInFolder}
                />
            </div>
        </FolderStyled>
    );
}

export default Folder;
